import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrangeToBack = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14252 15.5264C5.85366 15.2295 5.86017 14.7547 6.15704 14.4658C6.45392 14.177 6.92875 14.1835 7.2176 14.4804L9.25001 16.5692V5.97298C9.25001 5.55877 9.58579 5.22298 10 5.22298C10.4142 5.22298 10.75 5.55877 10.75 5.97298L10.75 16.5692L12.7824 14.4804C13.0713 14.1835 13.5461 14.177 13.843 14.4658C14.1399 14.7547 14.1464 15.2295 13.8575 15.5264L10.5375 18.9385C10.3964 19.0837 10.2025 19.1655 10 19.1655C9.79753 19.1655 9.60366 19.0837 9.46246 18.9385L6.14252 15.5264ZM7.5 13.5553L2.3698 10.9902C1.44849 10.5295 1.4485 9.21477 2.3698 8.75411L3.5588 8.15961L2.3698 7.56512C1.44849 7.10446 1.4485 5.7897 2.3698 5.32905L9.21737 1.90527C9.71005 1.65893 10.2899 1.65893 10.7826 1.90527L17.6302 5.32905C18.5515 5.78971 18.5515 7.10446 17.6302 7.56512L16.4412 8.15961L17.6302 8.75411C18.5515 9.21477 18.5515 10.5295 17.6302 10.9902L12.5 13.5553V11.8782L16.5122 9.87215L12.5 7.86607V6.18902L14.7641 7.32109L16.5122 6.44708L10.1118 3.24691C10.0414 3.21172 9.95858 3.21172 9.88819 3.24691L3.48784 6.44708L5.23585 7.32109L7.5 6.18901V7.86607L3.48784 9.87215L7.5 11.8782V13.5553Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrangeToBack
